import Enum from "../../../../../../enums/Enum";

const MentalStatusEnum = new Enum({
        KNOWS_OWN_LIMITS: {name: "Knows Own Limits"},
        OVERESTIMATES_OR_FORGETS_LIMITS: {name: "Overestimates or Forgets Limits"},
});

export default MentalStatusEnum;